import clsx from 'clsx';
import Structure from 'components/corporatiu/Structure';
import __isEmpty from 'lodash/isEmpty';
import styles from './fila.module.scss';

export default function Fila(props) {
    const { tipus, estil, className, columnes, columnesMobile, ordreMobile } = props;
    let { numColumnsRow } = props;
    const rowClass = 'row' + tipus;
    const colClass = 'col' + columnes;

    const colMobileClass = 'colMobile' + columnesMobile;

    const stylesRow = clsx({
        [styles.row]: true,
        [styles.reverse]: ordreMobile === 'reverse',
        [styles[rowClass]]: !__isEmpty(tipus),
        [styles[estil]]: !__isEmpty(estil)
    });

    const stylesCol = clsx({
        [styles[colClass]]: !__isEmpty(columnes),
        [styles[colMobileClass]]: !__isEmpty(columnesMobile),
        [className]: !__isEmpty(className)
    });

    if (!__isEmpty(numColumnsRow) && columnes) {
        const widthColumn = Array.isArray(numColumnsRow) && numColumnsRow.length > 0 ? numColumnsRow[0] : 12;
        const cols = columnes.split('_');
        numColumnsRow = cols.map((value) => (widthColumn / 12) * Number(value));
    } else {
        numColumnsRow = columnes ? columnes.split('_').map(Number) : [12];
    }

    const getContent = () => {
        if (!__isEmpty(props?.children)) {
            return props.children;
        } else {
            return <Structure {...props} numColumnsRow={numColumnsRow} />;
        }
    };

    return <div className={`${stylesRow} ${stylesCol}`}>{getContent()}</div>;
}
